import React, { ReactElement, useEffect, useRef, useState } from 'react';

import { WEB_APP_SIGNUP_URL } from '../../../../../globals';
import { Assets } from '../../../../../utils/assets';
import { MUSIC_TASK_LIST } from '../../constants';
import * as S from './ActivityCardScroll.styles';


export const ActivityCardScroll = (): ReactElement => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const [canScrollLeft, setCanScrollLeft] = useState<boolean>(false);
  const [canScrollRight, setCanScrollRight] = useState<boolean>(true);

  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [startX, setStartX] = useState<number>(0);
  const [scrollLeft, setScrollLeft] = useState<number>(0);

  const handleClickCta = () => {
    window.location.href = WEB_APP_SIGNUP_URL;
  };

  const updateScrollState = () => {
    const container = scrollRef.current;
    if (container) {
      const newMaxScroll = container.scrollWidth - container.clientWidth;

      const scrollLeft = container.scrollLeft;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < newMaxScroll);
    }
  };

  useEffect(() => {
    updateScrollState();

    const handleResize = () => {
      updateScrollState();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleScroll = () => {
    updateScrollState();
  };

  const scrollBy = (direction: 'left' | 'right') => {
    const container = scrollRef.current;
    if (container) {
      const scrollAmount = container.clientWidth * 0.35; // Scroll by 1 block (adjust as needed)
      container.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  const startDragging = (e: React.MouseEvent<HTMLDivElement>) => {
    const container = scrollRef.current;
    if (container) {
      setIsDragging(true);
      setStartX(e.pageX - container.offsetLeft);
      setScrollLeft(container.scrollLeft);
    }
  };

  const stopDragging = () => {
    setIsDragging(false);
  };

  const onDragging = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isDragging) return;

    const container = scrollRef.current;
    if (container) {
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 4; // The 4 multiplier adjusts the sensitivity
      container.scrollLeft = scrollLeft - walk;
    }
  };


  return (
    <S.Wrapper>
      <S.ScrollContainer
        ref={scrollRef}
        showLeftFade={canScrollLeft}
        showRightFade={canScrollRight}
        onMouseDown={startDragging}
        onMouseLeave={stopDragging}
        onMouseMove={onDragging}
        onMouseUp={stopDragging}
        onScroll={handleScroll}
      >
        {MUSIC_TASK_LIST.map((item, index) => (
          <S.Card key={index}>
            <S.CardHeader>
              <S.Title>
                {item.title}
              </S.Title>
              <S.Description>
              {item.description}
              </S.Description>
            </S.CardHeader>

            <S.ButtonLink onClick={handleClickCta}>
              <span>GET STARTED</span>
              <img alt="arrow" src="https://cdn.brain.fm/icons/arrow-right.svg" />
            </S.ButtonLink>
            <S.AuraImage alt={Assets.images.musicActivityFocusAura.alt} src={Assets.images.musicActivityFocusAura.url} />
            <S.Image src={item.imageSrc} />
          </S.Card>
        ))}
      </S.ScrollContainer>

      <S.ButtonContainer>
        <S.ScrollButton disabled={!canScrollLeft} onClick={() => scrollBy('left')}>
          <img alt="left" src="https://cdn.brain.fm/images/marketing/chevron_left.svg" />
        </S.ScrollButton>
        <S.ScrollButton disabled={!canScrollRight} onClick={() => scrollBy('right')}>
          <img alt="right" src="https://cdn.brain.fm/images/marketing/chevron_right.svg" />
        </S.ScrollButton>
      </S.ButtonContainer>
    </S.Wrapper>
  );
};
